import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyMasterDTO, CompanyMasterReadByIdRequestDTO, CompanyMasterUpdateRequestDTO } from 'src/app/AdvERP/companies/companies.interface';
import { CompaniesService } from 'src/app/AdvERP/companies/companies.service';
import { CompanyRelationDTO, CompanyRelationReadByIdRequestDTO, CompanyRelationUpdateRequestDTO } from 'src/app/Common/CompanyRelation/company-relation.interface';
import { CompanyRelationService } from 'src/app/Common/CompanyRelation/company-relation.service';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { ApiConfigurationDTO } from 'src/app/Common/ApiConfigurationService/api-configuration.interface';

@Component({
  selector: 'app-company-card-detail-view',
  templateUrl: './company-card-detail-view.component.html',
  styleUrls: ['./company-card-detail-view.component.css']
})
export class CompanyCardDetailViewComponent {

  @Input() companyId: number | null = null;  // Use null instead of 0 to prevent unnecessary API calls
  // Read-only override of the viewed tenant's own gateway URLs (Customer
  // Details page). Defaults to null so the other host of this component
  // (support-desk ticket-details) is unaffected - it never passes one.
  @Input() apiConfigOverride: ApiConfigurationDTO | null = null;
  // Unused here (CompanyMaster is identity-domain, no branch needed) - only
  // declared so the parent's blanket [defaultBranchId] binding compiles.
  @Input() defaultBranchId: number = 0;
  companyService = inject(CompaniesService);

  User = inject(UserLoginService).User();
  // private cRelationService = inject(CompanyRelationService)
  @Input() companyDetail!: CompanyMasterDTO;
  // CompanyData: CompanyRelationDTO | null = null;
  toaster = inject(ToastrService)
  // editingField: string | null = null; // <— NEW: Track which field is being edited
  editedValue: string = '';
  editingField: boolean = false;   // now used as edit mode flag
  backupCompanyDetail: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['companyId'] && this.companyId) {
      console.log("Fetching details for companyId:", this.companyId);
      this.fetchCompanyDetails(this.companyId);
    }
  }

  fetchCompanyDetails(id: number) {
    const body: CompanyMasterReadByIdRequestDTO = { tenantId: id };

    // CompanyMaster does NOT actually work routed via the Identity Server
    // (confirmed live, 2026-09-25 - despite being listed as identity-domain
    // in IDENTITY-SERVER-DESIGN.md), so this routes directly to the viewed
    // tenant's own server. The other host of this component (support-desk
    // ticket-details) never passes apiConfigOverride, so it's unaffected.
    this.companyService.CompanyMaster_readById(body, this.apiConfigOverride?.am, id, this.defaultBranchId).subscribe({
      next: (res) => this.companyDetail = res,
      error: (err) => console.error('Error fetching company details:', err)
    });
  }

  copyData(data: any) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(data).then(() => {
        console.log('Copied to clipboard:', data);
        // Optional: Add toast/snackbar notification here
        this.toaster.success('Details Copied')
      }).catch(err => {
        console.error('Failed to copy:', err);
      });
    } else {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = data;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log('Fallback: Copied to clipboard:', data);
        this.toaster.success('Details Copied')

      } catch (err) {
        console.error('Fallback: Failed to copy', err);
      }
      document.body.removeChild(textarea);
    }
  }

  // //  NEW: enable edit mode for a field
  // editField(field: string) {
  //   this.editingField = field;
  //   this.editedValue = (this.companyDetail as any)[field];
  // }


  editField() {
    this.editingField = true;
    this.backupCompanyDetail = JSON.parse(JSON.stringify(this.companyDetail));
  }

  //  NEW: when user presses Enter or blurs input, save automatically
  // saveField() {
  //   if (this.editingField) {
  //     (this.companyDetail as any)[this.editingField] = this.editedValue;

  //     // Here you can call your API update method
  //     this.companyService.CompanyMaster_update(this.companyDetail).subscribe({
  //       next: () => {
  //         this.toaster.success('Changes saved successfully');
  //         this.editingField = null;
  //       },
  //       error: (err) => {
  //         this.toaster.error('Error saving changes');
  //         console.error(err);
  //       }
  //     });
  //   }
  // }
  saveField(form: any) {
    if (form.invalid) {
      this.toaster.error('Please enter valid Email and Phone');
      return; // 
    }

    if (!this.companyDetail) {
      this.toaster.error('No company data to save');
      return;
    }

    let data: CompanyMasterUpdateRequestDTO = { ...this.companyDetail, actionUser: this.User.userId.toString() };

    this.companyService.CompanyMaster_update(data).subscribe({
      next: () => {
        this.toaster.success('Changes saved successfully');
        this.editingField = false;
      },
      error: (err) => {
        this.toaster.error('Error saving changes');
        console.error(err);
      }
    });
  }



  cancelEdit() {
    this.companyDetail = JSON.parse(JSON.stringify(this.backupCompanyDetail));
    this.editingField = false;
  }
  }
